module.exports = __webpack_public_path__ + "./images/8c4272f8240ce0a3fbb6cdb86231928b.webp";